import React, { useEffect, useState } from "react";
import { GoCheck } from "react-icons/go";
import { getApi } from "../AppApis";

const packagesArray = [
    {
        background: "tw-bg-[#FFFFFF]",
        title: "Essential Listing",
        price: "$0",
        titleColor: "#333333",
        subTitle: "$0",
        description: "Best for entry-level sellers exploring MLS exposure, providing a simple way to list on major platforms.",
        descriptionColor: "#64748B",
        offers: [
            { title: "MLS Listing", description: "Live within 24 hours on Zillow, Realtor, Trulia & more" },
            { title: "Photos", description: "Standard MLS limit" },
            { title: "Marketing Support", description: "Self-service (FAQs, Guides, Videos)" },
            { title: "Listing Period", description: "3 Months" },
            { title: "Compliance Fee", description: "0.50% at closing" },
        ],
        buttonTitle: "List for $0  Now",
        packageType: "basic",
    },
    {
        background: "tw-bg-gradient-to-tr tw-from-[#000000]  tw-to-[#6A6A6A] ",
        title: "MarketBlast Pro",
        titleColor: "white",
        subTitle: "$59",
        price: "$59",
        subTitleColor: "white",
        description: "Best for serious sellers aiming for maximum exposure, expert support, and unparalleled success.",
        descriptionColor: "#F7F8F9",
        offers: [
            { title: "MLS Listing", description: "All MarketBlast features plus priority support" },
            { title: "Photos", description: "Unlimited (MLS Max)" },
            { title: "Marketing Support", description: "Weekly Marketing Review & Refresh" },
            { title: "Listing Period", description: "12 Months" },
            { title: "Compliance Fee", description: "0.50% at closing" },
        ],
        offersColor: "white",
        buttonTitle: "Get Ultimate Exposure",
        packageType: "deluxe",
    },
    {
        background: "tw-bg-white",
        title: "MarketBlast",
        titleColor: "black",
        subTitle: "$29",
        price: "$29",
        subTitleColor: "black",
        description: "Best for intermediate sellers wanting better visibility & professional reviews to attract more buyers.",
        descriptionColor: "#64748B",
        offers: [
            { title: "MLS Listing", description: "Everything in Essential, plus enhanced marketing" },
            { title: "Photos", description: "MLS Max" },
            { title: "Marketing Support", description: "Monthly Marketing Review & Refresh" },
            { title: "Listing Period", description: "6 Months" },
            { title: "Compliance Fee", description: "0.50% at closing" },
        ],
        offersColor: "black",
        buttonTitle: "Dominate With Marketblast",
        packageType: "premium",
    },
];
const PackageCards = ({ setPackage_type, setSelectedPackage, setShowScreen, setActiveStep }) => {
    const [packageData, setPackageData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleAcitiveTab = (index) => {
        let item = packagesArray[index];
        let _item = packageData[index];
        if (item) {
            setPackage_type(item.packageType);
            setSelectedPackage({
                title: item.title,
                price: item.price,
                aminities: _item.information,
            });

            setShowScreen(1);
        }
    };

    useEffect(() => {
        const getPackages = async () => {
            setIsLoading(true);
            const response = await getApi("/packages");
            if (response.response?.data) {
                setPackageData(response.response?.data.packages);
            }
            setIsLoading(false);
        };
        getPackages();
    }, []);
    if (isLoading || packageData.length === 0) return <div>Loading</div>;
    return (
        <div className="">
            <h2 className="tw-text-[#333333] tw-text-[32px] tw-mt-[25px] tw-font-[700] tw-text-center">Choose the Perfect Package for Your Needs</h2>
            <p className="tw-text-[#1A1A1A] tw-text-center">
                Each package is backed by our cutting-edge AI technology, ensuring you receive data-driven insights and tools traditionally reserved
                for top-tier real estate professionals.
            </p>
            <div className="tw-grid tw-pt-10 tw-w-full tw-max-w-[1560px] tw-mx-auto lg:tw-grid-cols-3 lg:tw-items-center xl:tw-justify-between tw-justify-items-center tw-grid-cols-1 tw-gap-14 lg:tw-gap-8 xl:tw-gap-8 3xl:tw-gap-[50px] tw-mt-6">
                {/* first card  */}
                <div
                    className={`tw-bg-[#020407] tw-w-full tw-max-w-[490px] tw-h-full tw-relative tw-overflow-hidden tw-text-[#FAFAFA] tw-shadow tw-rounded-3xl tw-p-8 lg:tw-p-4 xl:tw-p-8 2xl:tw-p-10 hover:tw-mb-3 tw-transition-all tw-duration-300 hover:tw-scale-105 tw-mb-3`}
                >
                    <svg
                        className="tw-absolute -tw-right-40 tw-top-32"
                        width="303"
                        height="302"
                        viewBox="0 0 303 302"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="-61.3623"
                            y="165.483"
                            width="301.518"
                            height="301.518"
                            rx="150.759"
                            transform="rotate(-48.8283 -61.3623 165.483)"
                            fill="white"
                            fillOpacity="0.1"
                        />
                    </svg>
                    <svg
                        className="tw-absolute -tw-left-44 tw-bottom-14"
                        width="260"
                        height="260"
                        viewBox="0 0 303 302"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="-61.3623"
                            y="165.483"
                            width="301.518"
                            height="301.518"
                            rx="150.759"
                            transform="rotate(-48.8283 -61.3623 165.483)"
                            fill="white"
                            fillOpacity="0.1"
                        />
                    </svg>
                    <svg
                        className="tw-absolute -tw-left-32 tw-top-10"
                        width="240"
                        height="240"
                        viewBox="0 0 303 302"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="-61.3623"
                            y="165.483"
                            width="301.518"
                            height="301.518"
                            rx="150.759"
                            transform="rotate(-48.8283 -61.3623 165.483)"
                            fill="white"
                            fillOpacity="0.1"
                        />
                    </svg>

                    <div className="tw-absolute -tw-left-1 tw-top-7 tw-w-[65%] tw-flex tw-items-center tw-justify-center tw-font-semibold tw-text-base tw-text-[#FAFAFA]">
                        <svg viewBox="0 0 221 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.386719 0.477539H220.314L201.84 21.6244L220.314 42.7712H0.386719V0.477539Z" fill={`${"#E67E22"}`} />
                        </svg>
                        <p className="tw-absolute tw-font-bold tw-text-[14px] xl:tw-text-[17px]">{packageData[0]?.package_name}</p>
                    </div>

                    <div className="tw-flex tw-flex-col tw-gap-4 tw-mt-5 tw-mb-12">
                        <div className="tw-flex tw-items-center tw-mt-10">
                            <span className="tw-font-bold tw-text-[25px] xl:tw-text-[32px]">${packageData[0]?.price}</span>
                            <sub className="tw-text-[#FAFAFA] tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-font-medium tw-text-start">/Month</sub>
                        </div>

                        <div className="tw-space-y-1 lg:tw-space-y-2 2xl:tw-space-y-2.5">
                            <h3 className="tw-text-[13px] xl:tw-text-[16px] tw-font-semibold">Target Audience</h3>
                            <p className="tw-text-[#FAFAFA] tw-font-medium tw-text-[11px]">{packageData[0]?.description}</p>
                        </div>

                        <div className="">
                            <ul className="tw-space-y-1 lg:tw-space-y-2 2xl:tw-space-y-2.5 tw-text-base lg:tw-text-xs tw-font-medium tw-text-[#FAFAFA]">
                                {Object.entries(packageData[0]?.information).map(([key, value]) => (
                                    <li key={key} className="tw-flex tw-items-center">
                                        <div className="tw-bg-transparent tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-3">
                                            <GoCheck className="tw-p-1 tw-text-[16px] tw-text-primary  tw-rounded-full tw-h-fit tw-w-fit tw-bg-[#F0FDF9]" />
                                        </div>{" "}
                                        <div>
                                            <span className="tw-font-500"> {key}</span>: {value}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="tw-absolute tw-bottom-4 tw-w-[80%] tw-left-1/2 tw-transform -tw-translate-x-1/2">
                        <button
                            type="button"
                            onClick={() => handleAcitiveTab(0)}
                            className="tw-w-full tw-ease-in-out tw-duration-300 tw-px-4 tw-py-3 tw-text-[13px] tw-font-bold tw-tracking-wide tw-bg-white tw-text-[#000] tw-rounded-full hover:tw-bg-[#fafafa] hover:tw-tracking-wider"
                        >
                            {packageData[0]?.button_text}
                        </button>
                    </div>
                </div>

                <div
                    className={`tw-bg-primary tw-w-full tw-max-w-[490px] tw-h-full tw-relative tw-overflow-hidden tw-text-[#020407] tw-shadow tw-rounded-3xl tw-p-8 lg:tw-p-4 xl:tw-p-8 2xl:tw-p-10 hover:tw-mb-3 tw-transition-all tw-duration-300 tw-scale-105 hover:tw-scale-110 tw-mb-3`}
                >
                    <svg
                        className="tw-absolute -tw-right-40 tw-top-32"
                        width="303"
                        height="302"
                        viewBox="0 0 303 302"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="-61.3623"
                            y="165.483"
                            width="301.518"
                            height="301.518"
                            rx="150.759"
                            transform="rotate(-48.8283 -61.3623 165.483)"
                            fill="white"
                            fillOpacity="0.1"
                        />
                    </svg>
                    <svg
                        className="tw-absolute -tw-left-44 tw-bottom-14"
                        width="260"
                        height="260"
                        viewBox="0 0 303 302"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="-61.3623"
                            y="165.483"
                            width="301.518"
                            height="301.518"
                            rx="150.759"
                            transform="rotate(-48.8283 -61.3623 165.483)"
                            fill="white"
                            fillOpacity="0.1"
                        />
                    </svg>
                    <svg
                        className="tw-absolute -tw-left-32 tw-top-10"
                        width="240"
                        height="240"
                        viewBox="0 0 303 302"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="-61.3623"
                            y="165.483"
                            width="301.518"
                            height="301.518"
                            rx="150.759"
                            transform="rotate(-48.8283 -61.3623 165.483)"
                            fill="white"
                            fillOpacity="0.1"
                        />
                    </svg>
                    <div className="tw-absolute -tw-left-1 tw-top-7 tw-w-[55%] tw-flex tw-items-center tw-justify-center tw-font-semibold tw-text-base tw-text-[#FAFAFA]">
                        <svg viewBox="0 0 221 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.386719 0.477539H220.314L201.84 21.6244L220.314 42.7712H0.386719V0.477539Z" fill={`${"#E67E22"}`} />
                        </svg>
                        <p className="tw-absolute tw-font-bold tw-text-[14px] xl:tw-text-[17px]">{packageData[2]?.package_name}</p>
                    </div>
                    <div className="tw-flex tw-flex-col tw-gap-4 tw-mt-5 tw-mb-12">
                        <div className="tw-flex tw-items-center tw-text-4xl tw-font-bold tw-mt-10">
                            <span className="tw-font-bold tw-text-[25px] xl:tw-text-[32px] tw-text-white">${packageData[2]?.price}</span>
                            <sub className="tw-text-[#fff] tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-font-medium tw-text-start">/Month</sub>
                        </div>

                        <div className="tw-space-y-1 lg:tw-space-y-2 2xl:tw-space-y-2.5">
                            <h3 className="tw-text-[13px] xl:tw-text-[16px] tw-font-semibold tw-text-white">Target Audience</h3>
                            <p className="tw-text-[#fff] tw-font-medium tw-text-[11px]">{packageData[2]?.description}</p>
                        </div>

                        <div className="">
                            <ul className="tw-space-y-1 lg:tw-space-y-2 2xl:tw-space-y-3 tw-text-base lg:tw-text-xs tw-font-medium tw-text-[#fff]">
                                {Object.entries(packageData[2]?.information).map(([key, value]) => (
                                    <li key={key} className="tw-flex tw-items-center">
                                        <div className="tw-bg-transparent tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-3">
                                            <GoCheck className="tw-p-1 tw-text-[16px] tw-text-primary  tw-rounded-full tw-h-fit tw-w-fit tw-bg-[#F0FDF9]" />
                                        </div>{" "}
                                        <div>
                                            <span className="tw-font-500"> {key}</span>: {value}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="tw-absolute tw-bottom-5 -tw-mt-10 tw-w-[80%] tw-left-1/2 tw-transform -tw-translate-x-1/2">
                        <button
                            type="button"
                            onClick={() => handleAcitiveTab(1)}
                            className="tw-w-full tw-ease-in-out tw-duration-300 tw-px-4 tw-py-3 tw-text-[13px] tw-font-bold tw-tracking-wide tw-bg-white tw-text-primary tw-rounded-full hover:tw-bg-[#fafafa] hover:tw-tracking-wider"
                        >
                            {packageData[2]?.button_text}
                        </button>
                    </div>
                </div>

                {/* third card   */}
                <div
                    className={`tw-bg-[#020407] tw-w-full tw-max-w-[490px] tw-h-full tw-relative tw-overflow-hidden tw-text-[#FAFAFA] tw-shadow tw-rounded-3xl tw-p-8 lg:tw-p-4 xl:tw-p-8 2xl:tw-p-10 hover:tw-mb-3 tw-transition-all tw-duration-300 hover:tw-scale-105 tw-mb-3`}
                >
                    <svg
                        className="tw-absolute -tw-right-40 tw-top-32"
                        width="303"
                        height="302"
                        viewBox="0 0 303 302"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="-61.3623"
                            y="165.483"
                            width="301.518"
                            height="301.518"
                            rx="150.759"
                            transform="rotate(-48.8283 -61.3623 165.483)"
                            fill="white"
                            fillOpacity="0.1"
                        />
                    </svg>
                    <svg
                        className="tw-absolute -tw-left-44 tw-bottom-14"
                        width="260"
                        height="260"
                        viewBox="0 0 303 302"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="-61.3623"
                            y="165.483"
                            width="301.518"
                            height="301.518"
                            rx="150.759"
                            transform="rotate(-48.8283 -61.3623 165.483)"
                            fill="white"
                            fillOpacity="0.1"
                        />
                    </svg>
                    <svg
                        className="tw-absolute -tw-left-32 tw-top-10"
                        width="240"
                        height="240"
                        viewBox="0 0 303 302"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="-61.3623"
                            y="165.483"
                            width="301.518"
                            height="301.518"
                            rx="150.759"
                            transform="rotate(-48.8283 -61.3623 165.483)"
                            fill="white"
                            fillOpacity="0.1"
                        />
                    </svg>
                    <div className="tw-absolute -tw-left-1 tw-top-7 tw-w-[55%] tw-flex tw-items-center tw-justify-center tw-font-semibold tw-text-base tw-text-[#FAFAFA]">
                        <svg viewBox="0 0 221 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.386719 0.477539H220.314L201.84 21.6244L220.314 42.7712H0.386719V0.477539Z" fill={`${"#E67E22"}`} />
                        </svg>
                        <p className="tw-absolute tw-font-bold tw-text-[14px] xl:tw-text-[17px]">{packageData[1]?.package_name}</p>
                    </div>
                    <div className="tw-flex tw-flex-col tw-gap-4 tw-mt-5 tw-mb-12">
                        <div className="tw-flex tw-items-center tw-text-4xl tw-font-bold tw-mt-10">
                            <span className="tw-font-bold tw-text-[25px] xl:tw-text-[32px]">${packageData[1]?.price}</span>
                            <sub className="tw-text-[#FAFAFA] tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-font-medium tw-text-start">/Month</sub>
                        </div>

                        <div className="tw-space-y-1 lg:tw-space-y-2 2xl:tw-space-y-2.5">
                            <h3 className="tw-text-[13px] xl:tw-text-[16px] tw-font-semibold">Target Audience</h3>
                            <p className="tw-text-[#FAFAFA] tw-font-medium tw-text-[11px]">{packageData[1]?.description}</p>
                        </div>

                        <div className="">
                            <ul className="tw-space-y-1 lg:tw-space-y-2 2xl:tw-space-y-3 tw-text-base lg:tw-text-xs tw-font-medium tw-text-[#FAFAFA]">
                                {Object.entries(packageData[1]?.information).map(([key, value]) => (
                                    <li key={key} className="tw-flex tw-items-center">
                                        <div className="tw-bg-transparent tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-3">
                                            <GoCheck className="tw-p-1 tw-text-[16px] tw-text-primary  tw-rounded-full tw-h-fit tw-w-fit tw-bg-[#F0FDF9]" />
                                        </div>{" "}
                                        <div>
                                            <span className="tw-font-500"> {key}</span>: {value}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="tw-absolute tw-bottom-5 -tw-mt-10 tw-w-[80%] tw-left-1/2 tw-transform -tw-translate-x-1/2">
                        <button
                            type="button"
                            onClick={() => handleAcitiveTab(2)}
                            className="tw-w-full tw-ease-in-out tw-duration-300 tw-px-4 tw-py-3 tw-text-[13px] tw-font-bold tw-tracking-wide tw-bg-white tw-text-[#000] tw-rounded-full hover:tw-bg-[#fafafa] hover:tw-tracking-wider"
                        >
                            {packageData[1]?.button_text}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PackageCards;
